import { StarFilled } from '@ant-design/icons';
import { Tooltip, message } from 'antd';
import React, { useEffect, useState } from 'react';
import RequestApi from '@/fetch/bussiness/attention';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@/redux/store';
import SingleViewApis from '@/fetch/bussiness/singleView';
import qs from 'qs';
import {
  actionMultiVehicle,
  actionMultiStation,
  actionMultiCity,
} from '@/redux/action/common';
import { HttpStatusCode } from '@/fetch/core/constant';
import { debounce } from '@/utils/index';
import { clstagStr } from '@/utils/util';
interface Props {
  vehicleName: string[];
  attentionState: boolean;
  addAttentionClstag?: string;
  removeAttentionClstag?: string;
}

const AttentionIcon = (props: Props) => {
  const [negation, setNegation] = useState(false);
  const {
    attentionState,
    vehicleName,
    addAttentionClstag,
    removeAttentionClstag,
  } = props;
  const requestApi = new RequestApi();
  const dispatch = useDispatch();
  const common = useSelector((state: RootState) => state.common);
  const { vehicle, station, city } = common;
  const addAttention = async (
    event: React.MouseEvent<HTMLSpanElement>,
    vehicleName?: string[],
  ) => {
    event.stopPropagation();
    if (!vehicleName) {
      return;
    }
    const result = await requestApi.addAttention(vehicleName);
    if (result && result.code === HttpStatusCode.Success) {
      message.success('已添加为收藏');
      updateReduxAttentionData(vehicleName, true);
    } else {
      message.error('未成功收藏该车辆！');
    }
  };
  const removeAttention = async (
    event: React.MouseEvent<HTMLSpanElement>,
    vehicleName?: string[],
  ) => {
    event.stopPropagation();
    if (!vehicleName) {
      return;
    }
    const result = await requestApi.removeAttention(vehicleName);
    if (result && result.code === HttpStatusCode.Success) {
      message.success('已取消收藏');
      updateReduxAttentionData(vehicleName, false);
    } else {
      message.error('未成功取消收藏该车辆！');
    }
  };
  const updateReduxAttentionData = (
    vehicleName: string[],
    isAddAttention: boolean,
  ) => {
    //手动更新store中收藏状态、手动更新singleview中组件基本信息数据
    const newVehicle = JSON.parse(JSON.stringify(vehicle));
    for (let i = 0; i < vehicleName.length; i++) {
      const vehicleNameItem = vehicleName[i];
      for (const item in newVehicle) {
        if (newVehicle.hasOwnProperty(item)) {
          if (item == vehicleNameItem) {
            newVehicle[item].attentionState = isAddAttention;
          }
        }
      }
    }
    dispatch(actionMultiVehicle(newVehicle));
    updateStationAndCityAttentionState(newVehicle);
    if (location.pathname === '/app/single') {
      verifyDataConsistency(isAddAttention);
    }
  };
  const verifyDataConsistency = async (isAddAttention: boolean) => {
    const query = qs.parse(window.location.search.split('?')[1]);
    const license = query && query.license;
    const vehicleInfoResult = await SingleViewApis.fetchVehicleInfo(license);
    if (!vehicleInfoResult || !vehicleInfoResult.data) {
      return;
    }
    if (vehicleInfoResult && vehicleInfoResult.data) {
      const state = vehicleInfoResult.data.vehicleAttentionState;
      if (state === isAddAttention) {
        setNegation(!negation);
      } else {
        message.error('服务数据与显示不一致，刷新页面获取最新收藏状态！');
      }
    }
  };
  const updateStationAndCityAttentionState = (newVehicle: any) => {
    const newStation = JSON.parse(JSON.stringify(station));
    for (const item in newStation) {
      let stationAttentionState = true;
      for (const vehicleItem in newVehicle) {
        if (newVehicle[vehicleItem].pid.toString() === item) {
          if (!newVehicle[vehicleItem].attentionState) {
            stationAttentionState = false;
          }
        }
      }
      newStation[item].attentionState = stationAttentionState;
    }
    dispatch(actionMultiStation(newStation));
    const newCity = JSON.parse(JSON.stringify(city));
    for (const item in newCity) {
      let cityAttentionState = true;
      for (const vehicleItem in newVehicle) {
        if (newVehicle[vehicleItem].gid.toString() === item) {
          if (!newVehicle[vehicleItem].attentionState) {
            cityAttentionState = false;
          }
        }
      }
      newCity[item].attentionState = cityAttentionState;
    }
    dispatch(actionMultiCity(newCity));
  };
  const getState = () => {
    if (negation) {
      return !attentionState;
    }
    return attentionState;
  };
  return (
    <>
      {getState() ? (
        <Tooltip placement='top' title='取消收藏'>
          <span
            clstag={removeAttentionClstag && clstagStr(removeAttentionClstag)}
            onClick={(event) =>
              debounce(removeAttention(event, vehicleName), 500)
            }
            // style={{ float: 'right' }}
          >
            <StarFilled className='active-star' style={{ color: '#FF574D' }} />
          </span>
        </Tooltip>
      ) : (
        <Tooltip placement='top' title='添加收藏'>
          <span
            clstag={addAttentionClstag && clstagStr(addAttentionClstag)}
            onClick={(event) => debounce(addAttention(event, vehicleName), 500)}
            // style={{ float: 'right' }}
          >
            <StarFilled />
          </span>
        </Tooltip>
      )}
    </>
  );
};
export default React.memo(AttentionIcon);
